export default "__VITE_ASSET__DObp5lPD__"